import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Heading } from 'src/components/Heading';
import { Can, Subject } from 'src/hooks/usePermissions';
import { AutomationsTab } from '../components/AutomationsTab';
import { CreateCampaignDialog } from './components/CreateCampaignDialog';
import { StabilityLevel } from 'src/types/stability-level';

export const Automations = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isCreateCampaignFlow = searchParams.get('createCampaign') === '1';

  useEffect(() => {
    if (isCreateCampaignFlow) {
      setIsCreateOpen(true);
    }
  }, [isCreateCampaignFlow]);

  const handleCloseCreateCampaignDialog = () => {
    setIsCreateOpen(false);
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete('createCampaign');
    nextSearchParams.delete('campaignName');
    nextSearchParams.delete('campaignDescription');
    nextSearchParams.delete('campaignSchedule');
    setSearchParams(nextSearchParams);
  };

  return (
    <>
      <Heading
        title="Campaigns"
        subtitle="Set up campaigns to automate messages and calls."
        stabilityLevel={StabilityLevel.Beta}
      />

      <CreateCampaignDialog
        isOpen={isCreateOpen}
        onClose={handleCloseCreateCampaignDialog}
        onNext={() => setIsCreateOpen(false)}
      />

      <Can operation="read" subject={Subject.CAMPAIGNS}>
        {/* Render only when index is known (always true after first render) */}
        <AutomationsTab beta onNewCampaign={() => setIsCreateOpen(true)} />
      </Can>
    </>
  );
};
